import "./styles.css";

const runtimeConfig = {
  siteUrl: import.meta.env.VITE_PUBLIC_SITE_URL || window.location.origin,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "",
  sharedScriptUrl: import.meta.env.VITE_SHARED_SCRIPT_URL || "",
  siteCode: import.meta.env.VITE_SITE_CODE || "web-sites",
};

window.__ERICKSON_SITE_CONFIG__ = runtimeConfig;

function setRuntimeMeta() {
  document.documentElement.dataset.siteCode = runtimeConfig.siteCode;

  const metaTag = document.createElement("meta");
  metaTag.name = "erickson:api-base-url";
  metaTag.content = runtimeConfig.apiBaseUrl;
  document.head.appendChild(metaTag);
}

function injectSharedScript() {
  if (!runtimeConfig.sharedScriptUrl) {
    console.warn(
      "[web-sites] VITE_SHARED_SCRIPT_URL is not set. Shared lead form script is not connected.",
    );
    return;
  }

  const existingScript = document.querySelector('script[data-shared-script="lead-form"]');
  if (existingScript) {
    return;
  }

  const script = document.createElement("script");
  script.src = runtimeConfig.sharedScriptUrl;
  script.async = true;
  script.dataset.sharedScript = "lead-form";
  document.head.appendChild(script);
}

setRuntimeMeta();
injectSharedScript();
